import React from "react";
import { styled } from "@mui/material/styles";
import MuiIconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiTypography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Modal from "components/styled/modal/Modal";
import pxToRem from "libs/pxToRem";
import DocumentViewer from "components/business/documentViewer/DocumentViewer";
import { useSolicitudConsumoDocuments } from "components/hooks/useSolicitudConsumoDocuments";

interface ICertificadoAuditoriaModal {
  solicitudId: number | undefined;
  open: boolean;
  onClose: () => void;
}

const CertificadoAuditoriaModal = ({
  solicitudId,
  open,
  onClose,
}: ICertificadoAuditoriaModal) => {
  const { data: pdfUrl, isLoading } = useSolicitudConsumoDocuments(
    solicitudId,
    "certificado",
    open && !!solicitudId
  );

  const hasPdfUrl = Boolean(pdfUrl);

  return (
    <Modal
      onClose={onClose}
      opened={open}
      modalHeader={
        <Box>
          <IconButton aria-label="close" onClick={onClose} size="large">
            <CloseIcon />
          </IconButton>

          <ModalTitle>
            <Title>Certificado de Auditoría - Solicitud {solicitudId}</Title>
          </ModalTitle>
        </Box>
      }
      maxWidth="xl"
    >
      <DocumentViewer
        documentUrl={pdfUrl || ""}
        loading={isLoading}
        hasDocument={hasPdfUrl}
        emptyTitle="Certificado no disponible"
        emptyMessage="No hay un certificado de auditoría asociado a esta solicitud."
      />
    </Modal>
  );
};

export default CertificadoAuditoriaModal;

const Title = styled(MuiTypography)({
  fontSize: pxToRem(20),
  fontWeight: "bold",
  lineHeight: 1.89,
  letterSpacing: 0.45,
  textAlign: "center",
});

const SubTitle = styled(MuiTypography)({
  fontSize: pxToRem(15),
  fontWeight: "bold",
  lineHeight: 1.89,
  letterSpacing: 0.45,
  textAlign: "center",
  color: "#67717E",
});

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const ModalTitle = styled(MuiDialogTitle)({
  "&.MuiDialogTitle-root": {
    marginTop: pxToRem(15),
  },
});
